import Vue from 'vue'
import Axios from 'axios'
import App from '../News.vue'
import router from '../news/router'

import "trix/dist/trix.css"
import "trix"
import "@rails/actiontext"
import "../styles/actiontext_overrides.scss"

Vue.prototype.$http = Axios

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import 'bulma/css/bulma.min.css'

Vue.use(Buefy)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
